import React from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
import "../styles/AdminForgot.css"
// import {Link} from "react-router-dom";
import {useHistory} from 'react-router-dom'


function  AdminForgot() {
    const history = useHistory();
    const iniVal = {
        Email: '',
        cnEmail:''
    }
    const handleForgot = (values) => {
        console.log(values);
        if(values.Email === ''){
            alert('You need to Provide a email id')
           
            // 
        }
        else{
            AuthService.forgotPassword(values.Email).then(res => {
                if (res === "OTP has been sent on your email-id"){
                    history.push('/send_OTP')
                }
                console.log(res,"***************************")
                })
        }
    }
    return (
        <div className="forgotMain">
            <div className="forgotContainer">
                <h4>Provide your registered Email-id</h4>
                <Formik initialValues={iniVal} onSubmit={handleForgot}>
                    {
                        () => (
                            <Form>
                                <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="Email" as={TextField}  label="Email" variant="outlined" type="email" />
                                    {/* <Field name="cnEmail" as={TextField}  label="email" variant="outlined" type="email"/> */}
                                    <Button variant="contained" color="primary" type="submit">Send OTP</Button>
                                    {/* <Link className="link" to={"/send_OTP"}><Button variant="contained" color="primary" type="submit">Send OTP</Button></Link> */}
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default AdminForgot
